import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { NotificationHandler } from '@yakoffice/notification-handler';
import { ModalHandler } from '@yakoffice/custom-modal';
import { WithAuthentication, WithAuthorisation } from '@yakoffice/with-authorisation';
import { initYakofficeFirebaseApp } from '@yakoffice/yakoffice-firebase';
import { App } from './views/app';
import { rootStore, RootStoreProvider } from './models/StoresProviderContext';
import { SnackbarHandler } from '@yakoffice/snackbar';

initYakofficeFirebaseApp();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <NotificationHandler>
                <SnackbarHandler>
                    <ModalHandler>
                        <WithAuthentication>
                            <WithAuthorisation toolId="builds">
                                <RootStoreProvider value={rootStore}>
                                    <App />
                                </RootStoreProvider>
                            </WithAuthorisation>
                        </WithAuthentication>
                    </ModalHandler>
                </SnackbarHandler>
            </NotificationHandler>
        </BrowserRouter>
    </React.StrictMode>
);

